// Provenance is stored alongside primitive plan values so existing calculators
// retain their stable shapes.  Keys are plan paths, including stable group IDs.
const SOURCES = new Set(['manual', 'plan-document', 'plan-json', 'client-book', 'preset'])
const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)
const text = (value, max) => typeof value === 'string' ? value.trim().slice(0, max) : null

export function normalizeSettingMetadata(value = {}) {
  if (!isObject(value)) return {}
  return Object.fromEntries(Object.entries(value).flatMap(([path, record]) => {
    if (!isObject(record) || !path.trim()) return []
    const source = SOURCES.has(record.source) ? record.source : 'manual'
    return [[path, {
      source,
      sourceDocumentName: text(record.sourceDocumentName, 160),
      sourceExcerpt: text(record.sourceExcerpt, 500),
      sourcePage: Number.isInteger(record.sourcePage) && record.sourcePage > 0 ? record.sourcePage : null,
      confirmedAt: text(record.confirmedAt, 64),
      confirmedBy: text(record.confirmedBy, 120),
      effectiveDate: text(record.effectiveDate, 32),
      needsReconfirmation: record.needsReconfirmation === true,
    }]]
  }))
}
